import { render, staticRenderFns } from "./inputForm.vue?vue&type=template&id=ae6c2578&scoped=true"
import script from "./inputForm.vue?vue&type=script&lang=js"
export * from "./inputForm.vue?vue&type=script&lang=js"
import style0 from "./inputForm.vue?vue&type=style&index=0&id=ae6c2578&prod&lang=scss&scoped=true"
import style1 from "./inputForm.vue?vue&type=style&index=1&id=ae6c2578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6c2578",
  null
  
)

export default component.exports